import Utils from '../../../utils/utils';

class ReplacePage {
  static execute(target: string, payload: Record<string, string>, pageReference: string) {
    const actionPayload = {
      instruction: 'REPLACE',
      content: {
        ...Utils.unflatten(payload)
      }
    };

    const instruction = {
      target: Utils.buildInstructionPageReference(pageReference, target),
      content: { ...actionPayload.content },
      instruction: 'REPLACE'
    };

    return {
      instruction,
      actionPayload
    };
  }
}

export default ReplacePage;
